<template>
  <v-container
    fluid
    class="pa-0"
    :grid-list-md="$vuetify.breakpoint.xsOnly"
    :grid-list-xl="$vuetify.breakpoint.smAndUp"
    fill-height
  >
    <v-layout column class="scrollable custom-text-color">
      <v-flex class="px-2 overflow-auto">
        <v-fade-transition>
          <v-icon v-if="showArrow && !hideArrow" style="position: fixed; bottom: 10px; left: 50%; transform: translateX(-50%); z-index: 100;" large color="white">keyboard_arrow_down</v-icon>
        </v-fade-transition>
        <vue-markdown class="custom-text-color" :source="configuration ? configuration.configuration.thankyouText[$i18n.locale] : ''" :postrender="postRenderFormat" :anchorAttributes="{target: '_blank'}"></vue-markdown>
        <v-flex>
          <v-btn :block="$vuetify.breakpoint.xsOnly" round large class="custom-outline-btn mt-5" @click="$router.push({ name: routeNames.MAIN })">{{$t('result.back_to_main')}}</v-btn>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import routeNames from '@/router/route-names'
import MarkdownFormat from '@/mixins/MarkdownFormat'
import VueMarkdown from 'vue-markdown'
import ResponsivityMixins from '@/mixins/Responsivity'
import { mapState } from 'vuex'
export default {
  beforeRouteEnter (to, from, next) {
    if (from.name !== routeNames.REFUND) {
      next({ name: routeNames.MAIN, params: { instance: to.params.instance } })
    }
    next()
  },
  name: routeNames.RESULT,
  components: {
    VueMarkdown
  },
  mixins: [
    MarkdownFormat,
    ResponsivityMixins
  ],
  computed: {
    ...mapState(['configuration'])
  },
  data () {
    return {
      routeNames
    }
  }
}
</script>
